import React from 'react';

import { CustomThemeButton, type ThemeProps, type ThemeTokens } from '@atlaskit/button';
import { token } from '@atlaskit/tokens';

import { QuickSummaryIcon } from './assets/QuickSummaryIcon.tsx';
import type { QuickSummaryButtonStyles } from './QuickSummaryButton.tsx';

type QuickSummaryButtonWhitePlaceholderProps = {
	summarizeText: string;
	buttonStyles?: QuickSummaryButtonStyles;
};

export const QuickSummaryButtonWhitePlaceholder = ({
	summarizeText,
	buttonStyles = {},
}: QuickSummaryButtonWhitePlaceholderProps): React.JSX.Element => {
	const customTheme = (
		currentTheme: (props: ThemeProps) => ThemeTokens,
		theme: ThemeProps,
	): ThemeTokens => {
		const existingTheme = currentTheme(theme);
		const defaultStyles = {
			buttonStyles: {
				...existingTheme.buttonStyles,
				alignItems: 'center',
				gap: token('space.025'),
				padding: buttonStyles?.padding || `${token('space.050')} ${token('space.100')}`,
				border: buttonStyles?.border || existingTheme.buttonStyles.border,
				borderRadius: buttonStyles?.borderRadius || existingTheme.buttonStyles.borderRadius,
			},
		};

		return {
			...existingTheme,
			...defaultStyles,
		};
	};

	return (
		<CustomThemeButton
			theme={customTheme}
			spacing="none"
			appearance="subtle"
			isDisabled
			iconBefore={<QuickSummaryIcon label="" />}
			testId="ai-summarize-button-placeholder"
		>
			{summarizeText}
		</CustomThemeButton>
	);
};
